import * as Yup from 'yup';

export const prohibitedActivitiesSchema = Yup.object().shape({
    prohibitedActivities: Yup.boolean()
        .oneOf([true], 'You must accept it.')
        .required(),
});
